import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/fontawesome-free-regular/shakable.es'

import {
  faQuestionCircle, faUser, faUsers, faLock, faSignOutAlt, faCog, faCalendarAlt, faCalendar, faPhone, faMobile, faMobileAlt, faLocationArrow, faHome, faAngleUp, faInfoCircle, faTimesCircle, faExclamationTriangle, faExclamationCircle, faExchangeAlt, faPaperclip, faCheck, faChevronRight, faChevronLeft, faPlus, faMinus, faEdit, faTrashAlt, faSpinner, faTimes
} from '@fortawesome/fontawesome-free-solid/shakable.es'

fontawesome.library.add(
  faQuestionCircle, faUser, faUsers, faLock, faSignOutAlt, faCog, faCalendarAlt, faCalendar, faPhone, faMobile, faMobileAlt, faLocationArrow, faHome, faAngleUp, faInfoCircle, faTimesCircle, faExclamationTriangle, faExclamationCircle, faExchangeAlt, faPaperclip, faCheck, faChevronRight, faChevronLeft, faPlus, faMinus, faEdit, faTrashAlt, faSpinner, faTimes
)

Vue.component('fa', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/js/plugins/fontawesome.js